import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

const auth_messages = {
  "auth/user-not-found": "Invalid password",
  "auth/email-already-in-use": "Email already in use",
  "auth/wrong-password": "Invalid password",
  "auth/cancelled-popup-request": "Sign-in was cancelled",
  "auth/popup-closed-by-user": "Sign-in was cancelled",
  "auth/popup-blocked": "Sign-in popup was blocked. Please allow popups for this site.",
  "auth/account-exists-with-different-credential": "An account already exists with this email address",
  "auth/credential-already-in-use": "This credential is already associated with a different account",
  "auth/operation-not-allowed": "This sign-in method is not enabled",
  "auth/network-request-failed": "Network error. Please check your connection and try again",
  "auth/too-many-requests": "Too many failed attempts. Please try again later",
};

export { app, auth, auth_messages, db, functions, storage };
